__turbopack_context__.v({
  "button": "style-module-scss-module__sXfXgW__button",
  "component": "style-module-scss-module__sXfXgW__component",
  "pulse": "style-module-scss-module__sXfXgW__pulse",
  "pulseMobile": "style-module-scss-module__sXfXgW__pulseMobile",
  "visible": "style-module-scss-module__sXfXgW__visible",
});
